import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';

export default function RepSelector({ onSelect }) {
  const [visible, setVisible] = useState(false);
  const [reps, setReps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedId   = localStorage.getItem('tally_rep_id');
    const savedRole = localStorage.getItem('tally_rep_role');

    if (savedId && savedRole) {
      // Validate that the saved rep is still active before auto-selecting
      supabase
        .from('reps')
        .select('id, name, role, active')
        .eq('id', savedId)
        .single()
        .then(({ data, error }) => {
          if (!error && data && data.active) {
            // Rep is still active — auto-select
            onSelect(data.id, data.role);
            setLoading(false);
          } else {
            // Rep is inactive or not found — clear and show selector
            localStorage.removeItem('tally_rep_id');
            localStorage.removeItem('tally_rep_role');
            fetchReps();
          }
        });
    } else {
      fetchReps();
    }
  }, [onSelect]);

  async function fetchReps() {
    const { data, error } = await supabase
      .from('reps')
      .select('id, name, role')
      .eq('active', true)
      .eq('tally_visible', true)
      .order('name');
    if (!error && data) setReps(data);
    setLoading(false);
    setVisible(true);
  }

  function handlePick(rep) {
    localStorage.setItem('tally_rep_id', rep.id);
    localStorage.setItem('tally_rep_role', rep.role);
    onSelect(rep.id, rep.role);
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,0.75)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 20000, padding: '20px'
    }}>
      <div style={{
        background: '#1E293B', borderRadius: '20px', padding: '32px',
        width: '100%', maxWidth: '320px',
        border: '1px solid rgba(148,163,184,0.2)',
        boxShadow: '0 20px 60px rgba(0,0,0,0.5)'
      }}>
        <h2 style={{ margin: '0 0 8px 0', fontSize: '22px', fontWeight: '700', color: '#F8FAFC', textAlign: 'center' }}>
          Who are you?
        </h2>
        <p style={{ margin: '0 0 24px 0', fontSize: '14px', color: '#64748B', textAlign: 'center' }}>
          Your taps will be saved under your name
        </p>
        {loading ? (
          <p style={{ color: '#64748B', textAlign: 'center', fontSize: '14px' }}>Loading...</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {reps.map(rep => (
              <button
                key={rep.id}
                onClick={() => handlePick(rep)}
                style={{
                  padding: '14px 20px', borderRadius: '12px',
                  border: '1px solid rgba(148,163,184,0.2)',
                  background: 'rgba(148,163,184,0.08)',
                  color: '#F8FAFC', fontSize: '16px', fontWeight: '600',
                  cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit',
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                }}
                onMouseOver={e => e.currentTarget.style.background = 'rgba(96,165,250,0.15)'}
                onMouseOut={e => e.currentTarget.style.background = 'rgba(148,163,184,0.08)'}
              >
                <span>{rep.name}</span>
                <span style={{ fontSize: '12px', color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  {rep.role}
                </span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
